const defaultState = {
    historyTerm: [],
    loading: false,
    errors:{}
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

      case 'FETCH_HISTORY_TERM_FULFILLED': {
        return {
          ...state,
          historyTerm: action.payload.data,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_HISTORY_TERM_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_HISTORY_TERM_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
      
      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/history-term-reducer.js